module.exports = __webpack_public_path__ + "fac823e1d5c0ede1159ae78a4fa2edc9.pdf";